import { isPromise } from '@dimjs/lang';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AutoCenter } from '../../auto-center';
import { ModalAlert, ModalAlertProps } from '../../modal-alert';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';

export type TDialogAlertProps = Omit<
  ModalAlertProps,
  'visible' | 'getContainer' | 'onClose' | 'destroyOnClose' | 'children'
> & {
  content: string | JSX.Element;
};

const ModalRender = (props: TDialogAlertProps & BodyAppendDivElementProps) => {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    setVisible(true);
  }, []);

  const onClick = () => {
    if (props.onClick) {
      const response = props.onClick();
      if (response && isPromise(response)) {
        return response.then(() => {
          onClose();
        });
      }
    }
    onClose();
    return;
  };

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${props.elementId}`);
    props.onAfterClose?.();
  });

  return (
    <ModalAlert
      {...props}
      visible={visible}
      getContainer={props.divElement}
      onClose={onClose}
      onClick={onClick}
      onAfterClose={onAfterClose}
      destroyOnClose={true}
    >
      <AutoCenter>{props.content}</AutoCenter>
    </ModalAlert>
  );
};

export const dialogAlert = (props: TDialogAlertProps) => {
  const { divElement, elementId } = bodyAppendDivElement();
  ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
};
